import Head from 'next/head';
import { ThemePage } from '@/components/themes/ThemePage';
import { ThemeInitiatives } from '@/components/themes/ThemeInitiatives';
import { ThemeEntities } from '@/components/themes/ThemeEmtities';

const WORKPLACE_SUB_CATEGORIES = [
  {
    title: 'Office Pantry',
    description:
      'Stock your office kitchen with premium snacks, beverages, and healthy options that keep teams energised.',
  },
  {
    title: 'Team Events',
    description:
      'Product sampling and brand activations for team building days, Friday drinks, and company celebrations.',
  },
  {
    title: 'Wellness Programs',
    description:
      'Health-focused products for workplace wellness initiatives, mindfulness sessions, and fitness challenges.',
  },
  {
    title: 'Client Gifting',
    description:
      'Curated gift boxes and branded experiences for client appreciation, onboarding, and milestone celebrations.',
  },
  {
    title: 'Conference & Events',
    description:
      'Brand partnerships for corporate conferences, trade shows, and industry networking events.',
  },
  {
    title: 'Remote Team Care',
    description:
      'Delivered care packages and product drops for distributed teams, WFH days, and virtual events.',
  },
];

export default function WorkplaceThemePage() {
  return (
    <>
      <Head>
        <title>Workplace Initiatives | Sizzle</title>
        <meta
          name="description"
          content="Discover brand partnerships and activations for your workplace. From office pantry stocking to team events and wellness programs."
        />
      </Head>
      <ThemePage
        breadcrumbs={[{ label: 'Themes', href: '/themes' }, { label: 'Workplace' }]}
        title="Workplace focused opportunities"
        description="Partner with leading food, beverage, and wellness brands to energise your workplace. From office pantry stocking to team events and corporate gifting."
        heroImage=""
        // actions={[
        //   { label: 'Browse opportunities', href: '/opportunities', variant: 'primary' },
        //   { label: 'Browse partner brands', href: '/directory', variant: 'secondary' },
        // ]}
        subCategoriesTitle="Built for every workplace moment"
        subCategoriesSubtitle="Office pantries, team events, wellness programs, and client gifting — find the right brand partners for your workplace."
        subCategories={WORKPLACE_SUB_CATEGORIES}
      >
        <ThemeInitiatives
          title="Featured Initiatives"
          subtitle="Workplace-related initiatives."
          categories={['trade', 'workplace']}
          limit={6}
          themes={['workplace']}
        />

        <ThemeEntities
          title="Featured Brands and Businesses"
          // subtitle="Brands looking to partner with workplaces like yours."
          roles={['brand', 'supplier']}
          limit={8}
          themes={['campus']}
        />
      </ThemePage>
    </>
  );
}
